import React from 'react'

const Notification = () => {
  return (
    <div>
      <h2 className='text-blue text-center text-style-bold'>🔔 Notification</h2>
      <p>Instructor post an assignment</p>
      
    </div>
  )
}

export default Notification;
